import { useMediaQuery } from 'react-responsive';
import { theme } from '~/styles/theme';

export default function Responsive({ xs, sm, md, lg, xl }) {
  const isMobileXS = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm}px)`,
  });
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.md}px)`,
  });
  const isTablet = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.lg}px)`,
  });
  const isLarge = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.xl}px)`,
  });
  if (isMobileXS) return xs || sm || md || lg;
  if (isMobile) return sm || md || lg;
  if (isTablet) return md || lg || xl;
  if (isLarge) return lg || xl;
  return xl || lg || md || sm || null;
}
